import gql from 'graphql-tag';

export default gql`
query getAdminGlobalOverview($thirtyDaysAgo: timestamptz!) {
  totalAccounts: groups_aggregate {
    aggregate { count }
  }
  activeUsersLast30: users_aggregate(
    where: {last_login: {_gte: $thirtyDaysAgo}, deactivated: {_eq: false}}
  ) {
    aggregate { count }
  }
  totalUsers: users_aggregate(where: {deactivated: {_eq: false}}) {
    aggregate { count }
  }
  totalPublishedPages: pages_aggregate(where: {published: {_eq: true}}) {
    aggregate { count }
  }
  totalPublishedProjects: projects_aggregate(where: {published: {_eq: true}}) {
    aggregate { count }
  }
  pagesPublishedLast30: pages_aggregate(
    where: {published: {_eq: true}, published_at: {_gte: $thirtyDaysAgo}}
  ) {
    aggregate { count }
  }
}
`;
